import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { StickyContainer } from 'react-sticky';

import { Trans, useTranslation } from '../hooks/useTranslation';

const ErrorPage = ({ error }) => {
  const { t } = useTranslation('core');
  const stack = error.stack ? <pre style={{ padding: '30px', overflowX: 'auto' }}>{error.stack}</pre> : null;

  return (
    <StickyContainer>
      <div className="docs-single docs-error">
        <div className="js-doc-template container error-page">
          <img
            className="error-image"
            src="https://cdn2.auth0.com/website/docs/404/404-file-icon.svg"
            role="presentation"
          />
          <h2 className="error-status-code">
            {t('pages.errorPage.errorStatusCode', { statusCode: error.statusCode }, `${error.statusCode} Error`)}
          </h2>
          <h1 className="error-title">{t('pages.errorPage.errorTitle', { message: error.message }, error.message)}</h1>
          {error.statusCode === 404 ? (
            <p className="error-description">
              <Trans
                i18nKey="pages.errorPage.errorDescription404"
                ns="core"
                components={[<br key="0" />, <a href="https://auth0.com/docs" key="1" />]}
              >
                You may have mistyped the address or the page was moved or deleted. <br />
                You can search for more results or head to our <a href="https://auth0.com/docs">homepage</a>.
              </Trans>
            </p>
          ) : (
            <p className="error-description">
              <Trans
                i18nKey="pages.errorPage.errorDescriptionOther"
                ns="core"
                components={[<a href="https://support.auth0.com" key="0" />]}
              >
                For assistance open a support ticket at our <a href="https://support.auth0.com">Support Center</a>.
              </Trans>
            </p>
          )}
          {stack}
        </div>
      </div>
    </StickyContainer>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.object,
};

export default ErrorPage;
